import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatGrupoServico({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarGrupoServico();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarGrupoServico() {
    setLoading(true);
    const result = await monitorFaturamentoService.faturamentoGrupoServico(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.grupoServicoId ?? "sem-grupo",
    label: r.grupoServico,
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Faturamento por Grupo de Serviços"
      icone="ph-wrench"
      loading={loading}
    >
      <MonitorFatRankingBarra itens={itens} corBarra="#00897b" />
    </MonitorFatCard>
  );
}

export default MonitorFatGrupoServico;
